export const VenueSubscriptionSummaryFragment = /* GraphQL */ `
	fragment VenueSubscriptionSummary on Venue {
		_id
		updated_at
		vat
		service_charge
		service_charge_bd
		default_service_charge_type
		tax
	}
`;
